import { observable } from 'rewire-core';

export type TimecardMode = 'Timecard' | 'Summary';

interface ITimecardMode {
  mode: TimecardMode;
}

class TimecardModeModel {
  state: ITimecardMode;

  constructor() {
    this.state = observable({
      mode: 'Summary'
    });
  }

  get mode(): TimecardMode {
    return this.state.mode;
  }

  set mode(value: TimecardMode) {
    this.state.mode = value;
  }

  isMode(mode: TimecardMode): boolean {
    return timecardModeModel.mode === mode;
  }
}

const timecardModeModel = new TimecardModeModel();
export default timecardModeModel;